import { FormattedMessage } from 'react-intl';

const ExternalCollaboration = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="JiraSoftwarePricingPageTeam24.features.externalCollaboration.content.body"
					defaultMessage="Give people outside your org anonymous access to Jira projects."
				/>
			</p>
		</div>
	);
};

export default ExternalCollaboration;
